export default __webpack_public_path__ + "static/media/IMG_2126.a51dd4f9.jpg";